package app.view

import app.CustomRouter
import app.Routes
import app.api.DeployablesApi
import app.utils.formatDateTime
import dev.fritz2.core.RenderContext

fun RenderContext.deployablesView(deployablesApi: DeployablesApi) {
    div("dark:text-white") {
        deployablesApi.handler(Unit)
        deployablesApi.data.render { deployables ->
            if (deployables.isEmpty()) {
                +"No deployables found"
            } else {
                div("flex mt-4 mb-2 *:underline *:font-semibold") {
                    div("basis-1/2") {
                        +"Name"
                    }
                    div("basis-1/4") {
                        +"Latest Update"
                    }
                    div("basis-1/4") {
                        +"Date"
                    }
                }
            }
            deployables.forEach { deployable ->
                div("flex") {
                    div("basis-1/2") {
                        button("hover:underline") {
                            +deployable.name
                            clicks handledBy {
                                CustomRouter.deployable(
                                    mapOf(
                                        "route" to Routes.DEPLOYABLE,
                                        Routes.Params.DEPLOYABLE_NAME to deployable.name,
                                    )
                                )
                            }
                        }
                    }
                    div("basis-1/4") {
                        +"${deployable.version}"
                    }
                    div("basis-1/4") {
                        +formatDateTime(deployable.creationDate)
                    }
                }
            }
        }
    }
}
